import { API_VERSION, CLIENT_VERSION } from './version.js';

// `process.env.*` expressions are replaced literally at build time by
// esbuild's `define` (see webapp/build.mjs). In dev (unbuilt), these
// references would throw — but the app is only ever served from
// `webapp/dist/` post-build, so the strings are always inlined.

export const config = {
  apiUrl: process.env.SAYERMORE_API_URL || 'http://localhost:8080',
  apiVersion: API_VERSION,
  clientVersion: CLIENT_VERSION,
  clerkKey: process.env.CLERK_PUBLISHABLE_KEY || '',
  sentryDsn: process.env.SENTRY_DSN || '',
  dbName: 'sayermore-web',
  dbVersion: 1,
  storeName: 'captures',
  trialDays: 14,
  freeStorageBytes: 200 * 1024 * 1024, // 200 MB free local quota
};
